import { money } from '../format';

interface Props {
  daily: number | null;
  weekly: number | null;
  monthly: number | null;
}

/**
 * Period-scoped figures only. Lifetime `usage` is deliberately rendered in its own
 * column so the two can never be read as parts of one total.
 */
export function SpendCell({ daily, weekly, monthly }: Props) {
  const allNull = daily === null && weekly === null && monthly === null;
  if (allNull) {
    return <span className="muted">no spend reported</span>;
  }
  // "day/week/month" not "24h/7d/30d": these are OpenRouter's period counters that
  // reset at the period boundary, not rolling windows.
  return (
    <dl className="spend">
      <div>
        <dt>day</dt>
        <dd>{money(daily, '-')}</dd>
      </div>
      <div>
        <dt>week</dt>
        <dd>{money(weekly, '-')}</dd>
      </div>
      <div>
        <dt>month</dt>
        <dd>{money(monthly, '-')}</dd>
      </div>
    </dl>
  );
}
